/** Static mock operation for the M2M receipt gallery screen. */
export interface M2mMockReceipt {
  operationId: string;
  sendAmount: number;
  receiveAmount: number;
  totalCost: number;
  fundingFee: number;
  transactionFee: number;
  taxFee: number;
  exchangeRate: number;
  sourceCurrency: string;
  destinationCurrency: string;
  status: string;
  createdAt: string;
  receiverName: string;
  cancellation?: {
    allowed: boolean;
    mode?: "void" | "request";
    expiresAt?: string;
  };
}

export const m2mMockReceipt: M2mMockReceipt = {
  operationId: "m454f335",
  sendAmount: 400,
  receiveAmount: 6968,
  totalCost: 401,
  fundingFee: 1,
  transactionFee: 0,
  taxFee: 0,
  exchangeRate: 17.42,
  sourceCurrency: "USD",
  destinationCurrency: "MXN",
  status: "completed",
  createdAt: "2026-06-10T12:00:00.000Z",
  receiverName: "Jane Doe",
  cancellation: {
    allowed: true,
    mode: "request",
    expiresAt: "2099-01-01T00:00:00.000Z",
  },
};
